import { useCallback, useState } from 'react';
import dayjs from 'dayjs';
import timezonePlugin from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { useInterval } from '@frontend/design-system';
import { useCalendarGridStore } from '../../../store/calendar-grid.store';
import { timezoneToTimeIndicatorInfo } from '../../../utils';
import { TimeIndicator } from './time-indicator';

dayjs.extend(utc);
dayjs.extend(timezonePlugin);

const TIME_INDICATOR_UPDATE_INTERVAL = 60000; // Update every minute
const DEFAULT_TIMEZONE = dayjs.tz.guess();

interface Props {
  gridColumn: string;
  timezone?: string;
}

export const TodayTimeIndicator = ({ gridColumn, timezone = DEFAULT_TIMEZONE }: Props) => {
  const shouldRenderTimeIndicator = useCalendarGridStore((s) => s.timeIndicatorLines !== 'none');
  const [timeIndicatorInfo, setTimeIndicatorInfo] = useState<[string, number] | undefined>(
    timezoneToTimeIndicatorInfo(timezone)
  );

  const updateTimeIndicatorInfo = useCallback(() => {
    if (!timezone || !shouldRenderTimeIndicator) return;

    const info = timezoneToTimeIndicatorInfo(timezone);
    if (info) setTimeIndicatorInfo(info);
  }, [timezone, shouldRenderTimeIndicator]);

  useInterval(updateTimeIndicatorInfo, TIME_INDICATOR_UPDATE_INTERVAL);

  if (!timezone || !shouldRenderTimeIndicator) return null;

  if (!timeIndicatorInfo) return null;

  const [currentTime, rowNumber] = timeIndicatorInfo;

  return <TimeIndicator gridColumn={gridColumn} rowNumber={rowNumber} label={currentTime} />;
};
